import { render, staticRenderFns } from "./SystemMenu.vue?vue&type=template&id=061390af&scoped=true&"
import script from "./SystemMenu.vue?vue&type=script&lang=js&"
export * from "./SystemMenu.vue?vue&type=script&lang=js&"
import style0 from "./SystemMenu.vue?vue&type=style&index=0&id=061390af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061390af",
  null
  
)

export default component.exports